import type { EndpointDef } from '@skynet/data-helpers';

export const BUG_REPORTS_API_ENDPOINTS = {
  createBugReport: {
    generated: 'bugReportsControllerCreateBugReportV1',
    method: 'post',
    path: '/api/v1/bug-reports',
  },
} as const satisfies Record<string, EndpointDef>;

export type BugReportsEndpointName = keyof typeof BUG_REPORTS_API_ENDPOINTS;
